export default "__VITE_ASSET__B03M77At__"